import { has } from 'lodash';
import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';


const _getFurtherLearningCollections = (params) => {
    const { userCollectionId, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/furtherlearning/${userCollectionId}`;

    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.GET_FURTHER_LEARNING_COLLECTIONS_START
        });
        return VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_FURTHER_LEARNING_COLLECTIONS,
                payload: {
                    furtherLearningCollections: body
                }
            });

            return body;
        });
    };
};

export const getFurtherLearningCollections = (params) => _getFurtherLearningCollections(params);

export const clearFurtherLearningCollections = () => (dispatch) =>
    dispatch({
        type: ACTIONS.CLEAR_FURTHER_LEARNING_COLLECTIONS
    });
